import { render, staticRenderFns } from "./ChannelCommission.vue?vue&type=template&id=d7ef249e&scoped=true&"
import script from "./ChannelCommission.vue?vue&type=script&lang=js&"
export * from "./ChannelCommission.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCommission.vue?vue&type=style&index=0&id=d7ef249e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_kc4kqcj5wnuaaoi4dyztoye7yy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ef249e",
  null
  
)

export default component.exports